import React, { useEffect, useState, useCallback } from 'react';
import { throttle } from 'lodash';

import { ReactComponent as MicOffIcon } from '../../../assets/icon/mic-off.svg';
import { ReactComponent as MicOnIcon } from '../../../assets/icon/mic-on.svg';
import { interpolate } from '../../../utils/math';
import './Mic.css';
import { getIsSlowSettingEnabled } from '../../../services/LocalStorage';

const Mic: React.FC<{ height?: number; volume: number, isEnabled: boolean }> = ({ height = 18, volume, isEnabled }) => {
  const [vuLevel, setVuLevel] = useState<number>(12); // ~ 12 to 0

  useEffect(() => {
    handleVuMeterUpdate(volume);

    return () => { }
  }, [volume, height]);

  const handleVuMeterUpdate = useCallback(
    throttle((vuLevel: number) => {
      // const minClamp = 0.45;
      // const normalizedVuLevel = (10 * Math.log10(vuLevel * vuLevel || 1) + vuLevel / 1.23) / 1000;
      // const clampedToTopHalf = normalizedVuLevel * (1 - minClamp) + minClamp;
      // const inverted = 1 - clampedToTopHalf;
      // const finalFraction = inverted;

      // const iconOriginalHeight = 24;
      // const iconMaskMaxHeight = 22;
      // const iconScale = iconOriginalHeight / height;
      // const scaledMaskSize = iconScale * iconMaskMaxHeight;
      // const micMaxHeightAdjustedValue = finalFraction * scaledMaskSize;
      // const finalMicHeight = micMaxHeightAdjustedValue;
      const finalMicHeight = interpolate(vuLevel, 0, 0.5, 12, 0);
      // console.log('vol level: ', vuLevel, finalMicHeight);
      setVuLevel(finalMicHeight);
    }, getIsSlowSettingEnabled() ? 250 : 90),
    [height]
  );

  return (
    <div className="mic-container">
    {isEnabled ? (
      <>
        {/* <MicOnIcon /> */}
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              className="bottom"
              d="M11.999 14C13.5578 14 14.8161 12.66 14.8161 11V5C14.8161 3.34 13.5578 2 11.999 2C10.4402 2 9.18187 3.34 9.18187 5V11C9.18187 12.66 10.4402 14 11.999 14ZM17.5487 11C17.0886 11 16.7036 11.36 16.6285 11.85C16.2435 14.2 14.3184 16 11.999 16C9.67957 16 7.75453 14.2 7.36952 11.85C7.2944 11.36 6.90939 11 6.44926 11C5.87645 11 5.42571 11.54 5.51022 12.14C5.97035 15.14 8.22405 17.49 11.06 17.92V20C11.06 20.55 11.4825 21 11.999 21C12.5155 21 12.938 20.55 12.938 20V17.92C15.7739 17.49 18.0276 15.14 18.4878 12.14C18.5817 11.54 18.1216 11 17.5487 11Z"
            />
            <mask id="mask" mask-type="alpha" maskUnits="userSpaceOnUse" x="5" y="2" width="14" height="19">
              <rect x="5.5" y="2" width="13" height={vuLevel} fill="#C4C4C4" />
            </mask>
            <g mask="url(#mask)">
              <path
                className="top"
                d="M11.999 14C13.5578 14 14.8161 12.66 14.8161 11V5C14.8161 3.34 13.5578 2 11.999 2C10.4402 2 9.18187 3.34 9.18187 5V11C9.18187 12.66 10.4402 14 11.999 14ZM17.5487 11C17.0886 11 16.7036 11.36 16.6285 11.85C16.2435 14.2 14.3184 16 11.999 16C9.67957 16 7.75453 14.2 7.36952 11.85C7.2944 11.36 6.90939 11 6.44926 11C5.87645 11 5.42571 11.54 5.51022 12.14C5.97035 15.14 8.22405 17.49 11.06 17.92V20C11.06 20.55 11.4825 21 11.999 21C12.5155 21 12.938 20.55 12.938 20V17.92C15.7739 17.49 18.0276 15.14 18.4878 12.14C18.5817 11.54 18.1216 11 17.5487 11Z"
              />
            </g>
          </svg>
      </>
    ) : (
      <MicOffIcon />
    )}
    </div>
  );
};

export default Mic;
